import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assertSuccessfulWorkerResponse } from "./helpers";
import { showSuccessToast } from "../../utils/showToastAlert";

export function usePostParticipantActivate({
  callApiWithWorker,
  t,
  onErrorAlert,
}) {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ["participants", "activate"],
    mutationFn: async ({ participantId }) => {
      if (!participantId) throw new Error("Missing participantId");

      const res = await callApiWithWorker(
        `/registry/participants/${encodeURIComponent(participantId)}/active`,
        {
          method: "POST",
          connector: "springConnector",
        },
      );

      return assertSuccessfulWorkerResponse(
        res,
        "Activate participant failed",
      );
    },
    onSuccess: async (_data, vars) => {
      await qc.invalidateQueries({ queryKey: ["participants"] });
      await qc.invalidateQueries({
        queryKey: ["participants", "byId", vars?.participantId],
      });

      showSuccessToast(
        t?.(
          "participant.statusUpdate.updated.active",
          "Participant activated successfully",
        ),
        {
          title: t?.(
            "participant.statusUpdate.updatedTitle",
            "Updated successfully",
          ),
        },
      );
    },
    onError: async (err) => {
      if (onErrorAlert) return onErrorAlert(err);
      console.error(t ? t("error") : "Error", err);
    },
  });
}
